import { useEffect } from 'react'

/**
 * useOnClickOutside
 * hook to register click outside ref's element
 */

function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = event => {
      if (!ref) return
      const el = ref.current

      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains(event.target)) {
        return
      }

      handler(event)
    }

    document.addEventListener(`mousedown`, listener)
    document.addEventListener(`touchstart`, listener)

    return () => {
      document.removeEventListener(`mousedown`, listener)
      document.removeEventListener(`touchstart`, listener)
    }

    // Reload only if ref or handler changes
  }, [ref, handler])
}

export default useOnClickOutside



// WEBPACK FOOTER //
// ./src/hooks/useOnClickOutside.js